import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useModal } from 'hooks/3catinfo/useModal';
import { useViewport } from 'hooks/3catinfo/useViewport';
import clsx from 'clsx';
import styles from './tooltip.module.scss';

const calculateTooltipSize = async (tooltip) => {
    return new Promise((resolve) => {
        const tempDiv = document.createElement('div');
        tempDiv.style.position = 'absolute';
        tempDiv.style.top = '-9999px';
        tempDiv.style.left = '-9999px';

        document.body.appendChild(tempDiv);

        ReactDOM.render(tooltip, tempDiv, () => {
            const contentDiv = tempDiv.querySelector('span');
            const dimensions = {
                width: contentDiv.offsetWidth,
                height: contentDiv.offsetHeight
            };
            document.body.removeChild(tempDiv);
            resolve(dimensions);
        });
    });
};

const RenderTooltip = (props) => {
    const { content, direction = 'left', position = { top: 0, left: 0 }, estil } = props;

    const stylesContentTooltip = clsx({
        [styles.contentTooltip]: true,
        [styles[estil]]: true,
        [styles[direction]]: !!direction
    });

    const stylesTooltip = clsx({
        [styles.tooltip]: true,
        [styles[direction]]: !!direction
    });

    return (
        <div className={stylesContentTooltip} style={{ ...position }}>
            <span className={stylesTooltip}>{content}</span>
        </div>
    );
};

RenderTooltip.defaultProps = {
    estil: 'default'
};

const Tooltip = (props) => {
    const { target, content, estil } = props;
    const [visible, setVisible] = useState(false);
    const [tooltipSize, setTooltipSize] = useState(null);
    const { setModal, removeModal } = useModal();
    const { viewport, typesViewport } = useViewport();

    useEffect(() => {
        if (!target?.current) {
            return;
        }
        const targetCurrent = target?.current;
        const showTooltip = () => setVisible(true);

        const hideTooltip = () => {
            removeModal();
            setVisible(false);
        };

        calculateTooltipSize(<RenderTooltip content={content} estil={estil} />).then((dimensions) => {
            setTooltipSize(dimensions);
        });

        if (viewport !== typesViewport.VP_MOBILE) {
            targetCurrent.addEventListener('mouseenter', showTooltip);
            targetCurrent.addEventListener('mouseleave', hideTooltip);
        }

        return () => {
            if (targetCurrent && viewport !== typesViewport.VP_MOBILE) {
                targetCurrent.removeEventListener('mouseenter', showTooltip);
                targetCurrent.removeEventListener('mouseleave', hideTooltip);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [target, viewport]);

    useEffect(() => {
        if (visible && tooltipSize) {
            const rect = target.current.getBoundingClientRect();
            let tooltipPosition = {};
            let direction = 'left';
            if (rect.right + tooltipSize.width > window.innerWidth) {
                direction = 'right';
                const right = rect.right - tooltipSize.width;
                tooltipPosition = { top: `${rect.top}px`, left: `${right}px` };
            } else {
                tooltipPosition = { top: `${rect.top}px`, left: `${rect.left}px` };
            }
            setModal(<RenderTooltip content={content} direction={direction} position={tooltipPosition} estil={estil} />, {
                mode: 'flotant'
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible, tooltipSize]);

    return <></>;
};

export default Tooltip;
